import API_URL from "../config/config";
import axios from "axios";

const isPrivateDevelopmentHost = (hostname) =>
  hostname === "localhost" ||
  hostname === "127.0.0.1" ||
  hostname === "::1" ||
  /^192\.168\./.test(hostname) ||
  /^10\./.test(hostname) ||
  /^172\.(1[6-9]|2\d|3[0-1])\./.test(hostname);

// A printed QR can be opened outside the office network. Keep local testing on
// the configured LAN API, but always use the public TLS API for a live site.
export const getInvoiceApiUrls = () => {
  if (
    typeof window === "undefined" ||
    isPrivateDevelopmentHost(window.location.hostname)
  ) {
    return [String(API_URL).trim().replace(/\/+$/, "")];
  }

  // Health alone does not prove both deployments contain a manual invoice.
  // Only send its token to our configured public TLS backends, never an API
  // supplied in a QR/query string or a development LAN address on the live site.
  const candidates = [String(API_URL), API_URL.primary, API_URL.backup];
  return [...new Set(candidates.filter(Boolean).map((value) => {
    try {
      const url = new URL(String(value).trim());
      if (url.protocol === "https:" && !isPrivateDevelopmentHost(url.hostname)) {
        return url.toString().replace(/\/+$/, "");
      }
    } catch (_) {}
    return null;
  }).filter(Boolean))];
};

export const getInvoiceApiUrl = () => getInvoiceApiUrls()[0];

export const fetchPublicInvoice = async (orderId, token, { signal } = {}) => {
  let lastError;
  for (const apiUrl of getInvoiceApiUrls()) {
    try {
      const response = await axios.get(
        `${apiUrl}/invoice/public/${encodeURIComponent(orderId)}`,
        { params: { token }, timeout: 20000, signal },
      );
      if (response.data?.error || !response.data?.invoice) {
        throw new Error(response.data?.message || "Invoice not found.");
      }
      return { invoice: response.data.invoice, apiUrl };
    } catch (error) {
      if (signal?.aborted || axios.isCancel(error)) throw error;
      const status = error.response?.status;
      if (status && status !== 404 && status !== 408 && status !== 429 && status < 500) {
        throw error;
      }
      lastError = error;
    }
  }
  throw lastError || new Error("Invoice service is unavailable. Please try again.");
};
